<iframe style="display: none" frameborder="0"></iframe>

<nb-layout
  ><nb-layout-column
    ><h1 style="text-align: center">
      {{ logoutText | translate }}
    </h1></nb-layout-column
  ></nb-layout
>
